// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "7861a25a" + "." + "bec7c66f5bf4f922" + ".js";
};